import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

async function parseError(response, fallbackMessage) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || fallbackMessage);
}

export const fetchAdminSensors = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/sensors/admin/devices`);
    if (!response.ok) {
        await parseError(response, "Не вдалося завантажити сенсори");
    }
    return await response.json();
};

export const createAdminSensor = async (payload) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/sensors/admin/devices`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseError(response, "Не вдалося додати сенсор");
    }
    return await response.json();
};

export const updateAdminSensor = async (sensorId, payload) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/sensors/admin/devices/${encodeURIComponent(sensorId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseError(response, "Не вдалося оновити сенсор");
    }
    return await response.json();
};

export const verifyAdminSensorLicense = async (payload) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/sensors/admin/licenses/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseError(response, "Не вдалося перевірити sensor key");
    }
    return await response.json();
};

export const manageAdminSensorLicense = async (deviceId, payload) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/sensors/admin/devices/${encodeURIComponent(deviceId)}/license`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseError(response, "Не вдалося змінити ліцензію сенсора");
    }
    return await response.json();
};
